interface ReportMobileFieldProps {
  label: string
  children: React.ReactNode
}

export function ReportMobileField({ label, children }: ReportMobileFieldProps) {
  return (
    <div className="flex min-w-0 flex-col gap-0.5">
      <span className="text-[0.65rem] font-semibold uppercase tracking-wide text-muted-foreground">
        {label}
      </span>
      <span className="text-sm tabular-nums text-foreground [overflow-wrap:anywhere]">
        {children}
      </span>
    </div>
  )
}
